import useSWRMutationForm, { useErrorToSnackbar } from 'common-form/useSWRMutationForm';
import usePrequal from '../../resources/prequal/usePrequal';
import useApplicationUpdate from '../../resources/applications/update';

const useForm = () => {
  const { data: prequal } = usePrequal();
  const onSubmit = () => ({
    application: { offer_accepted: true },
  });

  const onSuccess = () => {
    if (prequal.preliminaryRedirectUri) {
      // Case: External checkout, redirect back to merchant
      window.location.replace(prequal.preliminaryRedirectUri);
    } else if (window.opener) {
      // Case: Widget, let the parent window know acceptance has occurred
      window.opener.postMessage('ACCEPTED', '*');
    }
  };

  return useSWRMutationForm({
    useMutation: () => useApplicationUpdate({ onSuccess }),
    onSubmit,
    useUnhandledError: useErrorToSnackbar,
  });
};

export default useForm;
